import { observer } from 'mobx-react';
import ApplyViewModel from './ApplyViewModel';
import { useNavigate, useParams } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { Appl } from '../../../../core/Appl';
import { Button, Container, View } from '../../../../core/components/Index';
import Helper from '../../../../core/services/Helper';
const DocuSignResponseView = observer(() => {

  const vm = Appl.Services.get<ApplyViewModel>('ApplyViewModel');
  vm.navigate = useNavigate();
  let { submissionId, memberId, envolopeId, documentId } = useParams();
  const searchParams = new URLSearchParams(location.search);
  useAsyncEffect(async () => {
    let event = searchParams?.get('event');
    await vm.submitApplicationAsync(submissionId!, memberId!, envolopeId!, documentId!, event!);

  }, []);

  return (
    <View id="DocuSignResponseView" showMenuBar={false}>
      {vm.docuSignMessage !== "" &&
        <Container>
          <div className="p-10  mx-auto">
            <div className="bg-white rounded-xl mb-4 py-20 px-10 text-center ">
              <h1 className="text-2xl md:text-3xl font-semibold mb-4">{vm.docuSignMessageTitle}</h1>
              <p>
                {Helper.formattedHtml(vm.docuSignMessage!)}
              </p>
              <Button title="Return to MySCERS" rounded onClick={() => window.location.href = `https://my.scers.gov`} />
            </div>
          </div>
        </Container>
        // <div className="gap-4 p-6 border-[2px] border-orange-500 bg-[#fbf5ef] flex rounded-md mb-4" >
        //   <div><svg viewBox="0 0 29 26" fill="none" xmlns="http://www.w3.org/2000/svg" className='w-7 h-7'>
        //     <path d="M14.4989 0.5C15.3033 0.5 16.0453 0.918527 16.4532 1.60491L28.6884 22.1406C29.1019 22.8326 29.1019 23.6864 28.6998 24.3783C28.2976 25.0703 27.5442 25.5 26.7342 25.5H2.2637C1.45368 25.5 0.700303 25.0703 0.298126 24.3783C-0.104051 23.6864 -0.0983867 22.827 0.309455 22.1406L12.5447 1.60491C12.9525 0.918527 13.6946 0.5 14.4989 0.5ZM14.4989 7.64286C13.7456 7.64286 13.1395 8.23996 13.1395 8.98214V15.2321C13.1395 15.9743 13.7456 16.5714 14.4989 16.5714C15.2523 16.5714 15.8584 15.9743 15.8584 15.2321V8.98214C15.8584 8.23996 15.2523 7.64286 14.4989 7.64286ZM16.3116 20.1429C16.3116 19.6693 16.1206 19.2151 15.7807 18.8802C15.4407 18.5453 14.9797 18.3571 14.4989 18.3571C14.0182 18.3571 13.5572 18.5453 13.2172 18.8802C12.8773 19.2151 12.6863 19.6693 12.6863 20.1429C12.6863 20.6165 12.8773 21.0707 13.2172 21.4055C13.5572 21.7404 14.0182 21.9286 14.4989 21.9286C14.9797 21.9286 15.4407 21.7404 15.7807 21.4055C16.1206 21.0707 16.3116 20.6165 16.3116 20.1429Z" fill="#CF7119" />
        //   </svg>
        //   </div>
        //   <div className='-mt-1'>
        //     <div className='text-orange-500 text-22px font-semibold mb-1 tracking--1percent'>{vm.docuSignMessageTitle}</div>
        //     <p className="text-black text-15px tracking--1_5percent">
        //       {Helper.formattedHtml(vm.docuSignMessage!)}
        //     </p>
        //   </div>
        // </div>
      }
    </View >
  );
});
export default DocuSignResponseView;



